module.exports = __webpack_public_path__ + "c87ca078819c2bae6b07ec7d766c518a.fbx";